import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialHierarchy2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 23.615H32v4.57h-1.53Zm-4.57 4.57h4.57v1.53H25.9Zm4.57-4.57v-1.52h-1.52v-4.57h-1.53v4.57H25.9v1.52zm-4.57-7.62h1.52v1.53H25.9Zm-1.52 7.62h1.52v4.57h-1.52Z\"/><path fill=\"currentColor\" d=\"M16.76 14.475v-4.57h1.52v-1.53h-4.57v1.53h1.52v4.57H6.09v1.52h9.14v6.1h-1.52v1.52h4.57v-1.52h-1.52v-6.1h9.14v-1.52zm1.52 9.14h1.52v4.57h-1.52Zm0-19.81h1.52v4.57h-1.52Zm-4.57 24.38h4.57v1.53h-4.57Zm0-25.9h4.57v1.52h-4.57Zm-1.52 21.33h1.52v4.57h-1.52Zm0-19.81h1.52v4.57h-1.52Zm-6.1 19.81h1.52v4.57H6.09Zm-1.52-7.62h1.52v1.53H4.57Zm-3.05 12.19h4.57v1.53H1.52Zm1.52-6.09H1.52v1.52h4.57v-1.52H4.57v-4.57H3.04zM0 23.615h1.52v4.57H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialHierarchy2
